import React, { useState } from 'react';
import './index.css';
import './i18n';
import Navigation from './components/Navigation';
import DashboardSubscriber from './components/DashboardSubscriber';
import DashboardSecurityFee from './components/DashboardSecurityFee';
import DashboardRegulatory from './components/DashboardRegulatory';
import RegulatoryBalanceDashboard from './components/RegulatoryBalanceDashboard';
import ManagementSubscriber from './components/ManagementSubscriber';
import ManagementSecurityFee from './components/ManagementSecurityFee';
import ManagementFileProcessing from './components/ManagementFileProcessing';
import ManagementAuthorization from './components/ManagementAuthorization';
import ManagementUserProfile from './components/ManagementUserProfile';
import ManagementAuditTrail from './components/ManagementAuditTrail';
import ManagementAccountStatus from './components/ManagementAccountStatus';
import ReportSubscribers from './components/ReportSubscribers';
import ReportSecurityFee from './components/ReportSecurityFee';
import ReportInvoiceByOperator from './components/ReportInvoiceByOperator';
import ReportSummary from './components/ReportSummary';
import Login from './components/Login';

function App() {
  const [activeTab, setActiveTab] = useState('Dashboard');
  const [activeSubMenu, setActiveSubMenu] = useState('Subscriber'); // Default to Subscriber for Management
  const [activeDashboardSubMenu, setActiveDashboardSubMenu] = useState('Subscriber Dashboard'); // Default dashboard submenu
  const [activeReportSubMenu, setActiveReportSubMenu] = useState('Subscribers Report'); // Default report submenu
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('authToken'));
  const [userRole, setUserRole] = useState(localStorage.getItem('userRole') || 'user');
  const [userName, setUserName] = useState(localStorage.getItem('userName') || '');

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userName');
    setUserRole('user');
    setUserName('');
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <Login onSuccess={(user) => { setUserRole(user?.role || 'user'); setUserName(user?.username || ''); setIsAuthenticated(true); }} />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        activeSubMenu={activeSubMenu}
        setActiveSubMenu={setActiveSubMenu}
        activeDashboardSubMenu={activeDashboardSubMenu}
        setActiveDashboardSubMenu={setActiveDashboardSubMenu}
        activeReportSubMenu={activeReportSubMenu}
        setActiveReportSubMenu={setActiveReportSubMenu}
        userRole={userRole}
        userName={userName}
        onLogout={handleLogout}
      />

      {activeTab === 'Dashboard' && (
        <div>
          {activeDashboardSubMenu === 'Subscriber Dashboard' && <DashboardSubscriber />}
          {activeDashboardSubMenu === 'Security Fee Dashboard' && <DashboardSecurityFee />}
          {activeDashboardSubMenu === 'Telecom Regulatory Dashboard' && <DashboardRegulatory />}
          {activeDashboardSubMenu === 'Regulatory Balance Dashboard' && <RegulatoryBalanceDashboard />}
        </div>
      )}

      {activeTab === 'Management' && userRole === 'admin' && (
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {activeSubMenu === 'Subscriber' && <ManagementSubscriber />}
          {activeSubMenu === 'Security Fee' && <ManagementSecurityFee />}
          {activeSubMenu === 'File Processing Monitor' && <ManagementFileProcessing />}
          {activeSubMenu === 'Authorization' && <ManagementAuthorization />}
          {activeSubMenu === 'User Profiles' && <ManagementUserProfile />}
          {activeSubMenu === 'Audit Trail' && <ManagementAuditTrail />}
          {activeSubMenu === 'Account Status' && <ManagementAccountStatus />}
        </main>
      )}

      {activeTab === 'Report' && (
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {activeReportSubMenu === 'Subscribers Report' && <ReportSubscribers />}
          {activeReportSubMenu === 'Security Fee Report' && <ReportSecurityFee />}
          {activeReportSubMenu === 'Invoice by Operator' && <ReportInvoiceByOperator />}
          {activeReportSubMenu === 'Summary Report' && <ReportSummary />}
        </main>
      )}
    </div>
  );
}

export default App;
